import { useRef } from 'react';
import { ProductDetailsListRow } from './ProductDetailsListRow';
import classes from './ProductDetailsSection.module.scss';

export interface ProductDetailsSectionItem {
  id: string;
  label: string;
  value: number | string;
}

interface ProductDetailsSectionProps {
  title: string;
  columnSize: 1 | 2 | 3;
  list1: Array<ProductDetailsSectionItem>;
  list2?: Array<ProductDetailsSectionItem>;
  list3?: Array<ProductDetailsSectionItem>;
  shouldNotCapValueLength?: boolean;
}

export const ProductDetailsSection = ({
  list1,
  list2,
  list3,
  title,
  columnSize,
  shouldNotCapValueLength,
}: ProductDetailsSectionProps) => {
  const containerRef = useRef<HTMLUListElement>(null);

  return (
    <div>
      <div className={classes.header}>{title}</div>
      <div className={classes.content}>
        <ul
          className={`${classes.contentList}`}
          style={{ width: `${100 / columnSize}%` }}
          ref={containerRef}
        >
          {list1.map(item => (
            <li key={item.id}>
              <ProductDetailsListRow
                {...item}
                shouldNotCapValueLength={shouldNotCapValueLength}
              />
            </li>
          ))}
        </ul>
        {list2 && (
          <ul
            className={`${classes.contentList}`}
            style={{ width: `${100 / columnSize}%` }}
            ref={containerRef}
          >
            {list2.map(item => (
              <li key={item.id}>
                <ProductDetailsListRow
                  {...item}
                  shouldNotCapValueLength={shouldNotCapValueLength}
                />
              </li>
            ))}
          </ul>
        )}
        {list3 && (
          <ul
            className={`${classes.contentList}`}
            style={{ width: `${100 / columnSize}%` }}
            ref={containerRef}
          >
            {list3.map(item => (
              <li key={item.id}>
                <ProductDetailsListRow
                  {...item}
                  shouldNotCapValueLength={shouldNotCapValueLength}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
